<template>
	<div class="boxBg">
		<h4>{{ analysisData.title }}</h4>
		<div class="tableBox">
		<table border="1">
			<tr v-for="(item, index) in analysisData.dataArrayList" :key="index" class="table_tr">
				<td v-for="(item1, index1) in item" :key="index1">{{ item1 }}</td>
			</tr>
			<tr v-if="analysisData.answerNumber != null">
				<td colspan="100">回答人数 : {{ analysisData.answerNumber }}</td>
			</tr>
		</table>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		analysisData: {
			type: Object //可指定接收类型，如:Array.
		}
	},
	data() {
		return {};
	}
};
</script>

<style scoped="scoped" lang="scss">
.boxBg {
	margin-top: 20px;
	background-color: #ffffff;
	padding: 10px;
}
h4 {
	text-align: center;
}
.tableBox{
	width: 90%;
	margin: 0 auto;
	overflow-x: auto;
}
table {
	// width: 90%;
	min-width: 900px;
	margin: 0 auto;
	border: 1px solid #dbdada;
	margin-bottom: 20px;
	border-collapse: collapse;
	border-spacing: 0;
	margin-top: 20px;
	overflow-x: auto;
}

table tr td {
	min-width: 50px;
	
	padding: 8px ;
	text-align: center;
}
</style>
